import { Button } from "antd";
import { CheckCircleFilled } from '@ant-design/icons';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useClient } from "../../context/ClientContext";
import { getContrastColor } from "../../utils/colorContrast";

export const PedidoConfirmation = () => {
  const navigate = useNavigate();
  const { clientId, theme , clientPath} = useClient();
  const [params] = useSearchParams();
  const pedidoId = params.get("external_reference");
  const primaryColor = theme?.primaryColor || '#197F56';
  const primaryTextColor = getContrastColor(primaryColor);

  return (
    <div style={{ minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 20px" }}>
      <div style={{ textAlign: "center", maxWidth: 480 }}>
        <CheckCircleFilled style={{ fontSize: 100, color: primaryColor }} />
        <h1 style={{ fontWeight: 700, marginTop: 16, marginBottom: 8 }}>¡Pago confirmado!</h1>
        <p style={{ fontSize: 16, color: "#666", marginBottom: pedidoId ? 12 : 28 }}>
          Tu pago fue procesado correctamente. Podés ver el estado y los detalles en Mis Pedidos.
        </p>
        {pedidoId && (
          <p style={{ fontSize: 14, color: "#999", marginBottom: 28 }}>Pedido #{pedidoId}</p>
        )}
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          {pedidoId && (
            <Button onClick={() => navigate(clientPath(`/mis-pedidos/${pedidoId}`))} style={{ fontWeight: 600, borderRadius: 8, padding: "6px 24px" }}>
              Ver pedido
            </Button>
          )}
          <Button
            type="primary"
            onClick={() => navigate(clientPath('/mis-pedidos'))}
            style={{ backgroundColor: primaryColor, borderColor: primaryColor, color: primaryTextColor, fontWeight: 700, borderRadius: 8, padding: "6px 32px" }}
          >
            Mis pedidos
          </Button>
        </div>
      </div>
    </div>
  );
};
